import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { onUserAcademy } from "../../redux/homeAction";
import Banner from "../Banner/Banner";
import Footer from "../Footer/Footer";
import Loader from "../loader/Loader";
import Navbar from "../Navbar/Navbar";

const Academy = () => {
  const dispatch = useDispatch();
  const [loader, setLoader] = useState(false);
  const classSend = "position-relative";

  const academyData = useSelector((state) => state.home.getUserAcademy);
  const articles = academyData?.result || [];

  const defaultImage = "/images/default-article.jpg";
  const placeholderImage = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 300 200'%3E%3Crect width='300' height='200' fill='%23cccccc'/%3E%3C/svg%3E";
  const [defaultImageLoaded, setDefaultImageLoaded] = useState(false);

  useEffect(() => {
    setLoader(true);
    dispatch(onUserAcademy(setLoader));

    const img = new Image();
    img.src = defaultImage;
    img.onload = () => setDefaultImageLoaded(true);
  }, []);

  return (
    <>
      <Navbar classSend={classSend} />
      <section className="awards_section">
        <div className="container">
          <h1 className="h1_60">
            IMPROVE YOUR <span className="color_yellow">KNOWLEDGE</span>
          </h1>
          <p className="P_gry_normal firstP">
            Triunfador's academy will help you acquire the fundamentals and
            tools to face the world of betting and casino in an intelligent,
            effective and profitable way; and will give you the best advice if
            you are interested in dabbling for real money.
          </p>
          {/* <div className="ad_section ad-top">
            <div className="row ad_content">
              <div className="col-md-12">
                <img src="./images/ad2.png" className="img-fluid" />
              </div>
            </div>
          </div> */}
          {articles.length > 0 ? (
            <>
              {loader ? (
                <div className="text-center">
                  <Loader />
                </div>
              ) : (
                <div className="awards_container academy_container">
                  {articles.map((article) => (
                    <div className="academy_box" key={article.id}>
                      <img 
                        src={article.image || (defaultImageLoaded ? defaultImage : placeholderImage)} 
                        className="product_img" 
                        alt={article.title}
                      />
                      <h5>{article.title}</h5>
                      <Link to={`/academy-blog/${article.slug}`}>
                        See More
                      </Link>
                    </div>
                  ))}
                </div>
              )}
            </>
          ) : (
            <div className="">
              <h2 className="text-center">No Articles Found</h2>
            </div>
          )}
          <Banner />
        </div>
      </section>

      <Footer />
    </>
  );
};

export default Academy;
